import React from 'react';

// One entry of the Share menu: an icon, a title and a line under it
export const ShareMenuItem = ({ icon, title, sub }) => (
    <span className="share-item">
        <span className="share-icon">{icon}</span>
        <span>
            <span className="share-title">{title}</span>
            <span className="share-sub">{sub}</span>
        </span>
    </span>
);
